export default __webpack_public_path__ + "static/kindergarten-readiness4-ec5a504d8699ded813db776809527638.jpg";